import BusinessSettingsNavigation from "@/business-settings/business-settings-navigation";
import { useBusiness } from "@/core/business";
import { useGetMyUser } from "@/user/query";

const PayrollSettingsNavigation = ({ isLoading }: { isLoading?: boolean }) => {
  const { businessId } = useBusiness();
  const { data: user } = useGetMyUser();
  return (
    <BusinessSettingsNavigation
      businessId={businessId ?? undefined}
      userRole={user?.role}
      isLoading={isLoading}
    />
  );
};
export default PayrollSettingsNavigation;
